import React from 'react';
import UOM from '../../../components/uom';
import getUomAbbreviationOrDescription from '../../../util/uom';
import {FILTER_STRATEGY} from "../../../components/connex-data-grid/util";

export const prototype = {
  id: '',
  name: '',
  status: 'ACTIVE',
};

export const columns = [
  {
    key: 'id',
    name: 'ID',
  },
  {
    key: 'name',
    name: 'Name',
  },
  // {
  //   key: 'componentType.name',
  //   name: 'Type',
  // },
  {
    key: 'uomCode',
    name: 'UOM',
    getValue: row => getUomAbbreviationOrDescription(row.uomCode),
  },
  {
    key: 'status',
    name: 'Status',
    filterStrategy: FILTER_STRATEGY.EQUALS,
    filterComponent: ({ innerRef, ...props }) => {
      return (
          <select ref={innerRef} {...props}>
            <option value="" />
            <option value="ACTIVE">Active</option>
            <option value="INACTIVE">Inactive</option>
          </select>
      );
    },
  },
];
